import { render, staticRenderFns } from "./ConfigPassword.vue?vue&type=template&id=395de62e&scoped=true&"
import script from "./ConfigPassword.vue?vue&type=script&lang=js&"
export * from "./ConfigPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPassword.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ConfigPassword.vue?vue&type=style&index=1&id=395de62e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395de62e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCard,VCardText,VCol,VContainer,VMain,VRow,VSpacer,VTextField})
